"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StockAvailabilityAlpha = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const LocalStorageUtil_1 = tslib_1.__importDefault(require("../../../util/LocalStorageUtil"));
const ProductSelector_1 = require("../../../redux/product/selectors/ProductSelector");
const StorageKeysConstants_1 = require("../../../constants/StorageKeysConstants");
const common_utils_1 = require("@as-react/common-utils");
const common_components_1 = require("@as-react/common-components");
const StockAvailabilityPopupAlpha_1 = require("../../stock-availability/StockAvailabilityPopupAlpha");
const common_queries_1 = require("@as-react/common-queries");
const react_query_1 = require("@tanstack/react-query");
const getProductSizes = (colorVariations) => {
    const sizes = new Map();
    colorVariations.forEach((productColor) => {
        if (productColor.sizes) {
            productColor.sizes.forEach((size) => {
                if (size.active && size.code) {
                    sizes.set(size.code, size);
                }
            });
        }
    });
    return Array.from(sizes.values()).sort((size, nextSize) => size.order - nextSize.order);
};
const parseStoreData = (storeStockData, productColors) => {
    var _a;
    const availability = [];
    (_a = storeStockData.colours) === null || _a === void 0 ? void 0 : _a.forEach((color) => { var _a; return (_a = color.sizes) === null || _a === void 0 ? void 0 : _a.forEach((size) => availability.push(size)); });
    return productColors.map((productColor) => {
        const color = {
            colorId: productColor.colorId,
            colorCode: productColor.colorCode,
            description: productColor.translations.description,
            swatch: productColor.swatch,
        };
        if (productColor.sizes) {
            const sizes = {};
            productColor.sizes.forEach((size) => {
                if (size.active) {
                    const availabilityBySku = availability.filter((avail) => String(avail.idSku) === String(size.sku))[0];
                    if (availabilityBySku && availabilityBySku.idSize) {
                        sizes[size.code] = availabilityBySku;
                    }
                }
            });
            color.sizes = sizes;
        }
        return color;
    });
};
const StockAvailabilityAlpha = ({ productId, productCode, productBrand, productTitle, }) => {
    const { oneSizeProductCode, productImageConfig, defaultRequestParams, servicesEndpoint } = (0, common_components_1.useAemConfig)();
    const colors = (0, react_redux_1.useSelector)((0, ProductSelector_1.makeGetAvailableColors)());
    const [selectedSku, setSelectedSku] = (0, react_1.useState)();
    const storeNumber = LocalStorageUtil_1.default.getJsonItem(StorageKeysConstants_1.SHOP_NUMBER_STORAGE_KEY);
    const productSizes = (0, react_1.useMemo)(() => getProductSizes(colors), [colors]);
    const { getProductAvailabilityForCurrentStore, getProductAvailabilityForAllStores } = (0, common_queries_1.storeErpQueries)({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { data: currentStoreData } = (0, react_query_1.useQuery)(getProductAvailabilityForCurrentStore({ productId, storeNumber }, {
        enabled: !!storeNumber,
        select: data => parseStoreData(data, colors),
    }));
    const { data: allStoresData } = (0, react_query_1.useQuery)(getProductAvailabilityForAllStores({ skuId: selectedSku }, {
        enabled: !!selectedSku,
    }));
    if (!productSizes) {
        return null;
    }
    const handleCellClick = (sku) => {
        if (!sku || sku === selectedSku)
            return;
        setSelectedSku(sku);
    };
    return ((0, jsx_runtime_1.jsx)(StockAvailabilityPopupAlpha_1.StockAvailabilityPopupAlpha, { productCode: productCode, productSizes: productSizes, selectedSku: selectedSku, currentStoreData: currentStoreData, allStoresData: allStoresData, isOneSizeProduct: (0, common_utils_1.isOneSizeProduct)(productSizes, oneSizeProductCode), productImageCdnDomains: productImageConfig.cdnDomains, productBrand: productBrand, productTitle: productTitle, onCellClick: handleCellClick }));
};
exports.StockAvailabilityAlpha = StockAvailabilityAlpha;
